export default __webpack_public_path__ + "static/media/seo-warning.f2c74590.svg";